// Pure capability override parsing — safe for server + client (no DOM).

import { KNOWN_CAPABILITIES, type Capability } from "./capabilities.js";

export type CapabilityOverrides = Partial<Record<Capability, boolean>>;

export function parseCapabilityOverrides(value: unknown): CapabilityOverrides {
  if (value === null || typeof value !== "object") return {};
  const raw = value as Record<string, unknown>;
  const out: CapabilityOverrides = {};
  for (const cap of KNOWN_CAPABILITIES) {
    const v = raw[cap];
    if (typeof v === "boolean") {
      out[cap] = v;
    }
  }
  return out;
}
